import React, { useState } from 'react';
import './Contact.css';
import BusinessCard from './BusinessCard';
import LetterForm from './LetterForm';

export default function Contact() {
  const [cardVersion, setCardVersion] = useState('v2');

  return (
    <section className="contact" id="contact">
      <div className="contact__inner">

        <div className="section-header">
          <p className="section-label">Let's Connect</p>
          <h2 className="section-title">Contact</h2>
          <div className="section-rule">
            <span className="section-rule__line" />
            <span className="section-rule__diamond" />
            <span className="section-rule__line" />
          </div>
        </div>

        <div className="contact__layout">

          {/* LEFT -- letter form */}
          <div className="contact__left">
            <p className="section-label contact__letter-label">
               -  Send a Message  - 
            </p>
            <LetterForm />
          </div>

          {/* RIGHT -- contact links + business card */}
          <div className="contact__right">

            {/* Contact links */}
            <div className="contact__links">
              <a className="contact__link-item" href="mailto:dmitriyfilimonov33@gmail.com">
                <span className="contact__link-label section-label">Email</span>
                <span className="contact__link-value">dmitriyfilimonov33@gmail.com</span>
              </a>
              <a
                className="contact__link-item"
                href="https://linkedin.com/in/dmitriy-filimonov/"
                target="_blank" rel="noopener noreferrer"
              >
                <span className="contact__link-label section-label">LinkedIn</span>
                <span className="contact__link-value">linkedin.com/in/dmitriy-filimonov</span>
              </a>
              <a
                className="contact__link-item"
                href="https://github.com/dtech982"
                target="_blank" rel="noopener noreferrer"
              >
                <span className="contact__link-label section-label">GitHub</span>
                <span className="contact__link-value">github.com/dtech982</span>
              </a>
              <a className="contact__link-item" href="tel:+14083728844">
                <span className="contact__link-label section-label">Phone</span>
                <span className="contact__link-value">408-372-8844</span>
              </a>
            </div>

            {/* Business card */}
            <div className="contact__card-area">
              <p className="section-label contact__card-intro">
                 -  Hover or swipe to flip &nbsp;·&nbsp; Hold to save  - 
              </p>
              <BusinessCard mode="portfolio" version={cardVersion} />
              <button
                type="button"
                className="contact__card-toggle"
                onClick={() => setCardVersion(v => (v === 'v2' ? 'v1' : 'v2'))}
              >
                {cardVersion === 'v2' ? 'View previous card' : 'View current card'}
              </button>
              <p className="contact__card-note">
                Compatible with iPhone, Android, Outlook &amp; Apple Contacts
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}